import AlignLeftIcon from '../design-system/Icons/AlignLeftIcon';
import TextBlockIcon from '../design-system/Icons/TextBlockIcon';
import ChatSmile2LineIcon from '../design-system/Icons/ChatSmile2LineIcon';

export const PLAYBOOK_VIEW_TYPE = {
    blocks: 'blocks',
    tabs: 'tabs',
};

export const PLAYBOOK_VIEW_TYPE_LABEL = {
    [PLAYBOOK_VIEW_TYPE.blocks]: 'Blocks View',
    [PLAYBOOK_VIEW_TYPE.tabs]: 'Tabs View',
};

export const TAB_TYPE = {
    overview: 'overview',
    form: 'form',
    prompt: 'prompt',
};

export const TAB_TYPE_LABEL = {
    [TAB_TYPE.overview]: 'Overview Tab',
    [TAB_TYPE.form]: 'Form Tab',
    [TAB_TYPE.prompt]: 'Prompt Tab',
};

export const TAB_TYPE_ICON = {
    [TAB_TYPE.overview]: AlignLeftIcon,
    [TAB_TYPE.form]: TextBlockIcon,
    [TAB_TYPE.prompt]: ChatSmile2LineIcon,
};
